import React from 'react';
import _ from 'lodash';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';

class RabbitModal extends React.Component {
    state = {
        lettersIdsArr: [],
    };

    handleCheck = this.handleCheck.bind(this);
    sendToRabbit = this.sendToRabbit.bind(this);

    handleCheck(id) {
        let idIndex = _.indexOf(this.state.lettersIdsArr, id)
        if(idIndex < 0) {
            this.setState(prevState => ({lettersIdsArr: _.uniq([...prevState.lettersIdsArr, id])}))
        } else {
            this.setState({lettersIdsArr: this.state.lettersIdsArr.filter((item, index) => index !== idIndex)});
        }
    };

    sendToRabbit() {
        if(this.state.lettersIdsArr.length) {
            this.props.sendToRabbit(this.state.lettersIdsArr);
            this.state.lettersIdsArr = [];
            this.props.handleClose();
        }
    }

    render() {
        const { open, handleClose, letters } = this.props;
        const lettersData = letters.data;

        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={() => {
                    this.state.lettersIdsArr = [];
                    handleClose();
                }}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onClick={this.sendToRabbit}
            />,
        ];

        return(
            <Dialog
                title="Requeue"
                actions={actions}
                modal={false}
                open={open}
                onRequestClose={() => {
                    this.state.lettersIdsArr = [];
                    handleClose();
                }}
                autoScrollBodyContent={true}
            >
                {
                    lettersData && lettersData.map((item, index) => {
                            return <Checkbox 
                                key={index}
                                value={item._id}
                                label={item.subject}
                                style={{marginTop: 16}}
                                onCheck={() => this.handleCheck(item._id)}
                            />;
                        }
                    )
                }
            </Dialog>
        );
    }
}

export default RabbitModal;


// WEBPACK FOOTER //
// ./app/components/Letters/List/RabbitModal.js